import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs';

@Injectable()
export class TranslationEffects {
  constructor(private actions$: Actions) {
  }

/*  @Effect()
  getTaxFormsCountries$ = this.actions$
    .pipe( ofType(POST_QUERY_SUCCESS_ACTION) )
    .pipe(
      map((action: PostQuerySuccessAction) => {
          if (action && action.data && action.data.taxFormsCountries) {
            const allCountries = this.getConvertedCountries(action.data.taxFormsCountries);
            return new SetTaxFormsCountriesAction(allCountries);
          } else {
            return new DoNothingAction();
          }
        }
      )
    );

  getConvertedCountries(countries: any) {
    countries = countries.map(country => {
      return {
        ...country,
        isChecked: true,
        id: country.code.toLowerCase()
      };
    });
    return countries;
  }*/

}

